import { render, staticRenderFns } from "./TransactionHistoryExportModal.vue?vue&type=template&id=ff07d598&scoped=true&"
import script from "./TransactionHistoryExportModal.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryExportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff07d598",
  null
  
)

export default component.exports